export default {
  NODE_ENV: "WEB_CONFIG",
  api_url: "https://api5.tempstars.ca/",
  AWS_REGION: "us-east-1",
  COGNITO_USER_POOL_ID: "us-east-1_yhWqNhAiA",
  COGNITO_USER_POOL_WEB_CLIENT_ID: "fn88oogf7p34is3oj1ui5bqi8",
  COGNITO_OAUTH_DOMAIN: "tempstars-agentadmin.auth.us-east-1.amazoncognito.com",
  OAUTH_REDIRECT_SIGNIN: "https://dashboard.tempstars.com/auth/callback",
  OAUTH_REDIRECT_SIGNOUT: "https://dashboard.tempstars.com/login",
  OAUTH_SCOPES: "email,openid,profile",
  OAUTH_RESPONSE_TYPE: "code",
  GOOGLEWORKSPACE_PROVIDER_NAME: "GoogleWorkspace",
};
